import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';
import Text from '../Text';

const PercentBarContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const PillContainer = styled.div`
  margin-right: 4px;
  display: flex;
  gap: 2px;
`;

const Pill = styled.div`
  background-color: ${themeGet('colors.black.10')};
  width: 4px;
  height: 12px;
  border-radius: 8px;
  flex-shrink: 0;
`;

const SolidPill = styled(Pill)`
  background: ${props => themeGet(`colors.${props.color}`)};
`;

const Pills = ({ percentage, color }) => {
  const solidPills = Math.round(parseFloat(percentage) / 10);

  return (
    <PillContainer>
      {[...Array(solidPills)].map((el, index) => (
        <SolidPill key={index} color={color} />
      ))}
      {[...Array(10 - solidPills)].map((el, index) => (
        <Pill key={index} />
      ))}
    </PillContainer>
  );
};

const PercentBar = ({ percentage = '0%', color = 'primary.100' }) => {
  // this safePercentage catches percentages over 100%, they shoudn't exist, but they do
  const safePercentage = parseInt(percentage, 10) > 100 ? '100%' : percentage;
  return (
    <PercentBarContainer>
      <Pills percentage={safePercentage} color={color} />
      <Text variant="small2" color="black.100">
        {safePercentage}
      </Text>
    </PercentBarContainer>
  );
};

export default PercentBar;
